/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetWorkbenchApiRequestsParams = zod.object({
	limit: zod.number().optional(),
	offset: zod.number().optional()
});

export type GetWorkbenchApiRequestsParams = zod.input<typeof GetWorkbenchApiRequestsParams>;
export type GetWorkbenchApiRequestsParamsOutput = zod.output<typeof GetWorkbenchApiRequestsParams>;
